import { createFileRoute } from '@tanstack/react-router';
import { RelatorioCadastroCatalogoProdutos } from '@/features/relatorio/page/cadastro/catalogo-produtos/RelatorioCadastroCatalogoProdutos';

export const Route = createFileRoute('/a/relatorio/cadastro/catalogo-produtos')({
    component: RelatorioCadastroCatalogoProdutos,
});
